import React from 'react';

const Experience = () => {
  const experiences = [
    {
      id: 1,
      title: 'Front-end Developer Intern',
      company: 'The Quick Cafe',
      date: 'March 2024 - June 2024',
      description:
        'Specialized in developing the frontend of their website using React, Redux, and Tailwind CSS, ensuring seamless user experience and performance optimization.',
    },
    {
      id: 2,
      title: 'Full Stack Developer Intern',
      company: 'Ignaite',
      date: 'Jan 2024 - June 2024',
      description:
        'Led frontend and backend development using MERN stack, addressing challenges and optimizing solutions for scalable web applications.',
    },
    {
      id: 3,
      title: 'President (Lead)',
      company: 'GeeksforGeeks Student Chapter, RCOEM',
      date: 'Aug 2023 - Sept 2024',
      description:
        'Coordinated and oversaw a multifaceted team consisting of 50+ individuals with diverse roles encompassing technology, media, content, and event management. Skillfully devised and implemented technology-driven events that promoted and cultivated awareness of the tech industry.',
    },
    {
      id: 4,
      title: 'Technical Team member',
      company: 'GeeksforGeeks Student Chapter, RCOEM',
      date: 'Sept 2022 - Aug 2023 ',
      description:
        ' Handled the ongoing maintenance and enhancements of the clubs website, ensuring it remained up-to-date for club events and various needs. Additionally, took charge of the planning and execution of technical events.',
      link: 'https://gfgrcoem.netlify.app/',
    },
    {
      id: 5,
      title: 'Technical Team member',
      company: 'TBI, RCOEM',
      date: 'March 2023 - Aug 2023 ',
      description:
        ' Ensured the continuous maintenance and updates of the website to accommodate various events and fulfill diverse requirements. Also, played a pivotal role in coordinating and organizing these events.',
      link: 'https://tbi-rcoem.web.app/',
    },
    // TODO: experiences as needed
  ];

  return (
    <div className="grid gap-6">
      {experiences.map((experience) => (
        <div key={experience.id} className="bg-white p-4 rounded-lg shadow-md border">
          <h2 className="text-lg font-bold">{experience.title}</h2>
          <h3 className="text-md text-gray-600 mb-2">{experience.company}</h3>
          <p className="text-sm text-gray-700 mb-4">{experience.date}</p>
          <p className="text-sm text-gray-800">{experience.description}</p>
          <a className="text-sm underline" target='_blank' rel='noreferrer' href={experience.link}>{experience.link}</a>
        </div>
      ))}
    </div>
  );
};

export default Experience;
